import { render, staticRenderFns } from "./MasterclassRegistration.vue?vue&type=template&id=72ec6a48&"
import script from "./MasterclassRegistration.vue?vue&type=script&lang=js&"
export * from "./MasterclassRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports